// extracted by mini-css-extract-plugin
export default {"products-container":"products-list_products-container__DQXJd","title-container":"products-list_title-container__AvKwY","products-title":"products-list_products-title__6xuzU"};